<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="1000px"
            @keydown.esc="closeDialog"
  >
  <v-card>
    <!-- layer_popWrap -->
    <div class="bt_wrap">
      <div class="popup_top">
        <button class="bt_close" @click="closeDialog">닫기</button>
        <span class="s_title">&nbsp;</span>
        <p><span class="b_title">참석자 등록</span></p>
      </div>
      <div class="popup_tel_wrap">
        <div class="member_warp">
          <div class="input_member">
            <input type="text" class="email" name="" placeholder="이메일">
            <input type="text" class="company" name="" placeholder="회사">
            <input type="text" class="position" name="" placeholder="직급">
            <input type="text" class="name" name="" placeholder="이름">
            <button class="send">입력</button>
          </div>
          <!-- //.input_member -->
        </div>
        <!-- .member_warp -->
        <div class="dataTable conference-info">
          <table class="info" cellpadding="0" cellspacing="0">
            <caption>이 표는 구성되어 있습니다.</caption>
            <colgroup>
              <col style="width:100px;" />
              <col style="width:20%;" />
              <col style="width:20%" />
              <col style="width:10%;" />
              <col style="width:15%;" />
            </colgroup>
            <tbody>
              <tr class="line">
                <td>
                  <span class="">
                    <input class="styled-checkbox" id="styled-checkbox-1" type="checkbox" value="value1">
                    <label for="styled-checkbox-1"></label>
                  </span>
                </td>
                <td>
                  <span class="">이메일</span>
                </td>

                <td>
                  <span class="">회사명</span>
                </td>

                <td>
                  <span class="">직급</span>
                </td>

                <td>
                  <span class="">이름</span>
                </td>
              </tr>
              <tr class="con">
                <td>
                  <span class="">
                    <input class="styled-checkbox" id="styled-checkbox-1" type="checkbox" value="value1">
                    <label for="styled-checkbox-1"></label>
                  </span>
                </td>
                <td>
                  <span class="">qwerry@naver.com</span>
                </td>

                <td>
                  <span class="">ECS</span>
                </td>

                <td>
                  <span class="">과장</span>
                </td>

                <td>
                  <span class="">홍길동</span>
                </td>
              </tr>
              <tr class="con">
                <td>
                  <span class="">
                    <input class="styled-checkbox" id="styled-checkbox-1" type="checkbox" value="value1">
                    <label for="styled-checkbox-1"></label>
                  </span>
                </td>
                <td>
                  <span class="">qwerry@naver.com</span>
                </td>

                <td>
                  <span class="">ECS</span>
                </td>

                <td>
                  <span class="">과장</span>
                </td>

                <td>
                  <span class="">홍길동</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- //.popup_tel_wrap -->
      <div class="btnArea">
        <button class="btn type3">선택삭제</button>
        <button class="btn type3 reset" @click="closeDialog">취소</button>
        <button class="btn type3 add">등록</button>
      </div>
    </div>
 <!-- /..bt_wrap -->
  </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';

export default {
  components: {
  },
  props: [
    'dialog',
    'closeDialog'
  ],
  data () {
    return {
      loading: true,
      error: null,
      isActive: true,
      personalAddress: [],
      filteredPersonalAddress: [],
      checkedMembers: [], /* 체크박스 유저 정보 */
      addedList: [], /* 선택 목록 */
      deleteMembers: [], /* 삭제 유저 정보 */
      searchText: '' /* 검색 명 */
    };
  },
  watch: {
    dialog: {
      handler (val) {
        this.loading = true;
        this.init();
      }
    }
  },
  methods: {
    async init () {
      this.searchText = '';
      this.error = null;
      await this.$http.get('/api/v1/users/personal-address', { params: { personal: this.$store.state.user.email }}).then((response) => {
        this.personalAddress = response.data.personalAddressData;
        this.personalAddress.forEach(obj => { obj['isPersonalAddr'] = true });
        this.filteredPersonalAddress = Object.assign([], this.personalAddress);
        this.loading = false;
      }).catch((error) => {
        console.log(error);
      });
    },
    addList () {
      console.log(this.checkedMembers);
      // 선택 목록 추가
      this.checkedMembers.forEach(item => {
        let idx = this.addedList.findIndex(i => i.email === item.email);
        if (idx === -1) {
          this.addedList.push(item);
        }
      });

      this.checkedMembers = [];
    },
    fucDeleteMembers (member, idx) {
      console.log(member);
      this.addedList.splice(idx, 1);
    },
    fucSearch (text) {
      console.log(text);
      if (text && text !== '') {
        this.filteredPersonalAddress = Object.assign([], this.personalAddress.filter(item => item.email.includes(text) || item.name.includes(text)));
      } else {
        this.filteredPersonalAddress = Object.assign([], this.personalAddress);
      }
    }
  }
};
</script>
<style scoped>
a {
  color: #464646;
  font-weight: 300;
}
.seltabcontent .seltab{
  width: 9%;
}
.p_ad {
  width: 42%;
  border: 1px solid #989898;
  border-radius: 5px;
  padding: 30px 15px 25px 15px;
  position: relative;
  font-weight: 500;
}

.seltab_r .scroll_tit li {
  float: left;
  height: 23px;
  padding-top: 7px;
  padding-bottom: 3px;
  text-align: center;
  border-top: 2px solid #fa4242;
  border-bottom: 1px solid #fa4242;
}

.checkbox {
  position: relative;
  font-size: 12px;
  float: none;
  padding: 0;
}
.checkbox input[type="checkbox"] {
    display: none;
}
.checkbox input[type="checkbox"]+label:before {
  position: unset;
  border: none;
}

.popContainer .checkbox  input[type="checkbox"] + label { 
  border: 1px solid #7f7f7f;
  display: inline-block; 
  width:12px; 
  height: 12px; 
  background: #fff;
  cursor: pointer; 
  border-radius:10px;
  position: unset;
  padding: 0;
}
.popContainer .checkbox :after {display:block; clear:both; content:"";}
.popContainer .checkbox input[type="checkbox"]:checked + label:before {
  position: unset;
  left: 0;
  top: 0;
  background: #fff;
  width: 0;
  height: 0;
  border: none;
}

.popContainer .checkbox input[type="checkbox"]:checked+label:after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  background: #fa4242;
  border-radius: 10px;
}

/* 선택목록 스크롤 바 */
.mCustomScrollbar::-webkit-scrollbar {
  width: 6px;
}
.mCustomScrollbar::-webkit-scrollbar-track {
  background-color: transparent;
}
.mCustomScrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.mCustomScrollbar::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.seltab .btn_com {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  color: white;
}
.btn_com{
  color: white;
}
.btn_linedf{
color: #fa4242;
}


/* 체크박스 */
.btn_check_box > .container-checkbox {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 17px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    float: left;
    margin-right: 10px;
    font-size: 17px;
    width: 100%;
}

.btn_check_box > .container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 100%;
    height: 30px;
    z-index: 100;
    top: -16px;
    right: 0px;
}

.btn_check_box > .container-checkbox .checkmark {
    position: absolute;
    border: 1px solid #7f7f7f;
    display: inline-block;
    width: 12px;
    height: 12px;
    background: #fff;
    cursor: pointer;
    border-radius: 10px;
    top: -5px;
    right: 18px;
}

/* On mouse-over, add a grey background color */
.btn_check_box > .container-checkbox:hover input ~ .checkmark {
    
}

/* When the checkbox is checked, add a blue background */
.btn_check_box > .container-checkbox input:checked ~ .checkmark {
    background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.btn_check_box > .container-checkbox .checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.btn_check_box > .container-checkbox input:checked ~ .checkmark:after {
    display: block;
    content: '';
    top: 1px;
    left: 1px;
    width: 10px;
    height: 10px;
    background: #fa4242;
    border-radius: 10px;
}

/* Style the checkmark/indicator */
.btn_check_box > .container-checkbox .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border-width: 0 3px 3px 0;
    
}

.btn_check_box {
  padding-top: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/popup/AddAttendeeDialog.vue